module.exports = __webpack_public_path__ + "static/UNL-0dac3cf5ae0cff61ea0b37499f17a918.ttf";